import "./styles.scss";

import React from "react";

import Heading from "components/Heading";
import PostCard from "components/PostCard";

const Guide = ({ list }) => {
  return (
    list?.length > 0 && (
      <section className="main-guide">
        <div className="main-guide__header">
          <div className="container">
            <Heading
              title="Przewodnik dla pacjenta"
              subtitle="Najnowsze publikacje"
            />
          </div>
        </div>
        <div className="main-guide__posts">
          {list.map((item, index) => {
            const isLatest = index === 0;

            return (
              <div key={index}>
                <div className="container">
                  <PostCard
                    url={`/${item.post.slug}/`}
                    image={item.post.featuredImage?.node?.sourceUrl}
                    title={item.post.title}
                    description={item.post.excerpt}
                    author={{
                      image: item?.post?.author?.node?.avatar?.url,
                      name: item?.post?.author?.node?.name,
                    }}
                    date={item?.post?.acfPost?.postUpdateDate?.replaceAll(
                      "/",
                      "."
                    )}
                    categories={item?.post?.categories?.nodes.map(
                      (category) => ({
                        name: category.name,
                        url: `/blog/${category.slug}/`,
                      })
                    )}
                    badge={isLatest ? "Najnowszy wpis" : undefined}
                    variant={isLatest ? "red" : undefined}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </section>
    )
  );
};

export default Guide;
